module.exports = __webpack_public_path__ + "static/media/pc-instruction.20eb0c6e.mp4";